import Container from './container';
import history from './util/history';
// Hook for server
if (typeof require.ensure !== 'function') {
    require.ensure = function (dependencies, callback) {
        callback(require);
    };
}
let routes = [
    {
        path: '/',
        component: Container,
        indexRoute: { onEnter: () => history.replace('/myvideo') },
        childRoutes: [
            {
                path: '/creativehot',
                getComponent(nextState, callback) {
                    require.ensure([], (require) => {
                        callback(null, require('./views/creative-hot-list'));
                    }, 'creativehot');
                }
            },
            {
                path: '/mywork',
                onEnter(_, replace) {
                    replace('/myvideo?tabIndex=1'); // mlog跳转
                }
            },
            {
                path: '/mymv',
                onEnter(_, replace) {
                    replace('/myvideo?tabIndex=0'); // mv跳转
                }
            },
            {
                path: '/myvideo',
                getComponent(nextState, callback) {
                    require.ensure([], (require) => {
                        callback(null, require('./views/myvideo'));
                    }, 'myvideo');
                }
            },
            {
                path: '/talent',
                getComponent(nextState, callback) {
                    require.ensure([], (require) => {
                        callback(null, require('./views/talentPlan/index'));
                    }, 'talent');
                }
            },
            {
                path: '/plan',
                getComponent(nextState, callback) {
                    require.ensure([], (require) => {
                        callback(null, require('./views/plan'));
                    }, 'plan');
                }
            },
            {
                path: '/watermark',
                getComponent(nextState, callback) {
                    require.ensure([], (require) => {
                        callback(null, require('./views/watermark/watermark'));
                    }, 'watermark');
                }
            },
            // 黑胶视频设置页的路由
            {
                path: '/musicbgvideo',
                getComponent(nextState,callback) {
                    require.ensure([], (require) => {
                        callback(null, require('./views/music-bg-video'));
                    }, 'music-bg-video');
                }
            },
            {
                path: '*',
                onEnter: () => history.replace('/myvideo')
            }
        ]
    }
];

function getRoutes(User) {
    const { type, companyParticipateState } = User.cashEncourageState;
    const { data } = User;

    if (type === 2 && companyParticipateState === 2) {
        // 公司账户
        routes = [{
            path: '/',
            component: Container,
            indexRoute: {
                indexRoute: { onEnter: () => history.replace('/plan') }
            },
            childRoutes: [
                {
                    path: '/plan',
                    getComponent(nextState, callback) {
                        require.ensure([], (require) => {
                            callback(null, require('./views/plan'));
                        }, 'plan');
                    }
                },
                {
                    path: '*',
                    onEnter: () => history.replace('/plan')
                }
            ]
        }];
    }

    return routes;
}

export default getRoutes;



// WEBPACK FOOTER //
// ./client/router.js